import { PostStatusPropertyValue } from 'api/clients/PropertyClient'
import { Button } from 'blaze-ui/Button'
import { ButtonProps } from 'blaze-ui/Button/Types'

const getButtonLabel = (status: PostStatusPropertyValue) => {
  switch (status) {
    case PostStatusPropertyValue.Draft:
      return 'Choose How to Post'
    case PostStatusPropertyValue.ReminderScheduled:
      return 'Change Reminder'
    case PostStatusPropertyValue.AutoPostScheduled:
      return 'Change Post Date'
    case PostStatusPropertyValue.Posted:
      return 'Change Status'
    case PostStatusPropertyValue.Failed:
      return 'Reschedule'
    default:
      return 'Choose How to Post'
  }
}

export const PostStatusDropdownButton = ({ ...props }: ButtonProps & { status: PostStatusPropertyValue }) => {
  return <Button {...props}>{getButtonLabel(props.status)}</Button>
}
